var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-avatar",style:(_vm.avatarStyle)},[(_vm.hasSlot)?[_vm._t("default")]:_c('span',[_vm._v(_vm._s(_vm.avatarLetters))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }